import React from "react";
import "../rejectDialog/RejectDialog.css";

const StatusConfirmDialog = ({
  open,
  title = "Are you sure you want to change status?",
  message = "",
  confirmLabel = "Confirm",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="reject-modal-overlay">
      <div className="reject-modal-content">
        <h2 className="reject-modal-title">{title}</h2>
        <div className="reject-modal-icon">
          <span>?</span>
        </div>
        {message ? (
          <p style={{ color: "#082a51", marginBottom: "16px" }}>{message}</p>
        ) : null}
        <div className="reject-modal-actions">
          <button className="reject-modal-btn reject" onClick={onConfirm}>
            {confirmLabel}
          </button>
          <button className="reject-modal-btn cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusConfirmDialog;

export const STATUS_LABELS = {
  1: "In Process",
  3: "Pending For Approval",
  4: "Approved",
  5: "Rejected",
  7: "Renewal",
  20: "Assigned to Company",
  in_process: "In Process",
  pending_for_approval: "Pending For Approval",
  approved: "Approved",
  rejected: "Rejected",
  descrepency_GB_GB: "Discrepancies",
  renewal: "Renewal",
  assign_to_company: "Assigned to Company",
};
